import React, { type FunctionComponent, useEffect, useCallback } from 'react'
import instacart from 'legacy/common/instacart'
import groupUser from 'utils/events/groupUser'
import identifyUser, { buildUserEventPayload } from 'utils/events/identifyUser'
import { GlobalContext, type GlobalContextValue } from 'legacy/contexts/global/GlobalContext'
import {
  type CurrentPartnerUser,
  useFetchCurrentPartnerUser,
} from 'legacy/contexts/global/queries/currentPartnerUser'
import { errors } from 'utils/error-handling/errors'

interface Props {}

const GlobalProvider: FunctionComponent<Props> = ({ children }) => {
  const { currentPartnerUser, loading } = useFetchCurrentPartnerUser()

  const handleLogout = useCallback(async () => {
    await instacart.logout()
  }, [])

  // Configure Sentry and segment settings for user
  useEffect(() => {
    async function configureUserAnalytics(user: CurrentPartnerUser) {
      // Sentry configuration
      errors.setUser({ id: user.uuid })

      // Identify user/group on segment
      identifyUser(user)
      groupUser(user)
    }

    if (currentPartnerUser) {
      configureUserAnalytics(currentPartnerUser)
    }
  }, [currentPartnerUser])

  if (loading) return null

  const contextValue: GlobalContextValue = {
    loading,
    user: currentPartnerUser || null,
    onLogout: handleLogout,
  }

  return <GlobalContext.Provider value={contextValue}>{children}</GlobalContext.Provider>
}

export default GlobalProvider
